/**
 * author: Ananthapadmanabhan V K
 */
import { faker } from '@faker-js/faker';
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS, Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip
} from "chart.js";
import React, { useContext, useEffect, useState } from "react";
import { OverlayTrigger, Popover, ProgressBar, Tab, Tabs } from "react-bootstrap";
import { Bar, Doughnut, Line } from "react-chartjs-2";
import { withTranslation } from "react-i18next";
import { RegulationContext } from "../../../App";
import { CompanyDashboardGraphType, currentYear, startYear } from "../../../core/constants/common";
import CompanyDashboardService from "../../../core/service/CompanyDashboardService";
import Utils from "../../../core/utilities/Utils";
import SupplierRiskCountCard from "../../Common/Supplier/SupplierRiskCountCard";
import CompanyRiskCard from "../CompanyRiskCard/CompanyRiskCard";
import "./CompanyDashboard.scss";

import 'react-circular-progressbar/dist/styles.css';
import { AiOutlineFileText } from 'react-icons/ai';
import { BsInfoCircle } from "react-icons/bs";
import { CgSortAz } from "react-icons/cg";
import { METRIC_CODE } from '../../../core/constants/common';
import CompanyGraphCard from '../CompanyDashboardGraph/CompanyGraphCardOLD';
import EmptyGraphDataCard from '../CompanyDashboardGraph/EmptyGraphDataCard';


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const graphoptions = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
      display: false,
    },
    title: {
      display: true,
      text: "",
    },
  },
};



const graphoptions_right = {
  responsive: true,

  plugins: {
    legend: {
      position: "right",
    },
    title: {
      display: false,
      text: "",
    },
    datalabels: {
      formatter: (value) => {
        return value + '%';
      },
    },

  },
};
const graphoptions_Horizontal = {
  indexAxis: 'y',
  elements: {
    bar: {
      borderWidth: 1.5,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: 'bottom',
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false
      }
    },
    y: {
      grid: {
        display: false
      }
    }
  }
};
const Stacked_options = {
  plugins: {
    title: {
      display: false,
    },
  },
  responsive: true,
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
    },
  },
};
const isDemoEnv = process.env.REACT_APP_ENV === 'demo';

// Initial chart data structure
const initialChartData = {
  label: [],
  datasets: []
};

const CompanyDashboardOLD = ({ t }) => {
  // All hooks must be called first, before any code that could throw
  const [tabkey, setTabKey] = useState('Environmental')
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const [riskparamdata, setRiskParamData] = useState([]);
  const [highrisksupplier, setHighRiskSupplier] = useState([]);
  const [highriskcountries, setHighRiskCountries] = useState([]);
  const [companyrisk, setCompanyRisk] = useState(null);
  const [labelscountry, setLabelsCountry] = useState([]);
  const [countrygraphdata, setCountryGraphData] = useState(null);
  const [frequency, setFrequency] = useState("");
  const [annualyear, setAnnualYear] = useState(new Date().getFullYear());
  const [frequencymonth, setFrequencyMonth] = useState('');
  const [configType, setConfigType] = useState('Supplier');
  const [countrytopfive, setCountryTopFive] = useState([]);
  const [totalWorkForce, setTotalWorkForce] = useState(0);
  const [Workforce_Type, setWorkforce_Type] = useState({ ...initialChartData });
  const [diversity_doughnut, setDiversityDoughnut] = useState({ ...initialChartData });
  const [diversity_male, setDiversityMale] = useState({ ...initialChartData });
  const [diversity_female, setDiversityFemale] = useState({ ...initialChartData });
  const [newhires_doughnut, setNewHiresDoughnut] = useState({ ...initialChartData });
  const [newhire_female, setNewhireFemale] = useState({ ...initialChartData });
  const [newhire_male, setNewhireMale] = useState({ ...initialChartData });
  const [water_withdrawal_data, setWaterWithdrawalData] = useState({ ...initialChartData });
  const [graphFooter, setGraphFooter] = useState({ total: 0, comparison: 0 });
  const [frequencyParam, setFrequencyParam] = useState("");
  const [topic, setTopic] = useState('Energy');
  
  // Safe code that could throw - moved after all hooks
  const colorCode = {
    backgroundColor: "rgb(255, 193, 7)",
  };
  const lsDat = JSON.parse(localStorage.getItem("authority") || "{}");
  const companyId = lsDat?.profile?.company?.id || null;
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const options = [];
  for (let i = currentYear; i >= startYear; i--) {
    options.push(<option value={i} key={i}>{i}</option>);
  }
  const energyProducedInside = 'analytics_report/302-1/' + frequencyParam;

  useEffect(() => {
    if (glbRegulationId) {
      setFrequency(glbRegulation.frequency);
      const month = Utils.getMonthFromFrequency(glbRegulation.frequency);
      setFrequencyMonth(month);
      getDashboardData(annualyear, month);
      getWaterWithdrawal();
    }
  }, [glbRegulationId, annualyear]);
    
  const getWaterWithdrawal = () => {
    CompanyDashboardService.getWaterWithdrawal(glbRegulation.id, `${annualyear}-01-01`)
      .then((response) => {
        var resData = response['data'].data;
        // return
        var graph_dat = {
          labels,
          datasets: [
            {
              label: 'Fresh Water',
              data: [resData['January'].FRESH_WATER, resData['February'].FRESH_WATER,
              resData['March'].FRESH_WATER, resData['April'].FRESH_WATER,
              resData['May'].FRESH_WATER, resData['June'].FRESH_WATER,
              resData['July'].FRESH_WATER, resData['August'].FRESH_WATER,
              resData['September'].FRESH_WATER, resData['October'].FRESH_WATER,
              resData['November'].FRESH_WATER, resData['December'].FRESH_WATER],
              borderColor: '#07B401',
              backgroundColor: '#C1EDC0',
            },
            {
              label: 'Other Water',
              data: [resData['January'].OTHER_WATER, resData['February'].OTHER_WATER,
              resData['March'].OTHER_WATER, resData['April'].OTHER_WATER,
              resData['May'].OTHER_WATER, resData['June'].OTHER_WATER,
              resData['July'].OTHER_WATER, resData['August'].OTHER_WATER,
              resData['September'].OTHER_WATER, resData['October'].OTHER_WATER,
              resData['November'].OTHER_WATER, resData['December'].OTHER_WATER],
              borderColor: '#397FF4',
              backgroundColor: '#D7E5FD',
            },
            {
              label: 'Fresh Water from area with water stress',
              data: [resData['January'].FRESH_WATER_FROM_WATER_STRESS_AREA, resData['February'].FRESH_WATER_FROM_WATER_STRESS_AREA,
              resData['March'].FRESH_WATER_FROM_WATER_STRESS_AREA, resData['April'].FRESH_WATER_FROM_WATER_STRESS_AREA,
              resData['May'].FRESH_WATER_FROM_WATER_STRESS_AREA, resData['June'].FRESH_WATER_FROM_WATER_STRESS_AREA,
              resData['July'].FRESH_WATER_FROM_WATER_STRESS_AREA, resData['August'].FRESH_WATER_FROM_WATER_STRESS_AREA,
              resData['September'].FRESH_WATER_FROM_WATER_STRESS_AREA, resData['October'].FRESH_WATER_FROM_WATER_STRESS_AREA,
              resData['November'].FRESH_WATER_FROM_WATER_STRESS_AREA, resData['December'].FRESH_WATER_FROM_WATER_STRESS_AREA],
              borderColor: 'rgba(255, 206, 86, 1)',
              backgroundColor: 'rgba(255, 206, 86, 0.5)',
            },
            {
              label: 'Other Water from area with water stress',
              data: [resData['January'].OTHER_WATER_FROM_WATER_STRESS_AREA, resData['February'].OTHER_WATER_FROM_WATER_STRESS_AREA,
              resData['March'].OTHER_WATER_FROM_WATER_STRESS_AREA, resData['April'].OTHER_WATER_FROM_WATER_STRESS_AREA,
              resData['May'].OTHER_WATER_FROM_WATER_STRESS_AREA, resData['June'].OTHER_WATER_FROM_WATER_STRESS_AREA,
              resData['July'].OTHER_WATER_FROM_WATER_STRESS_AREA, resData['August'].OTHER_WATER_FROM_WATER_STRESS_AREA,
              resData['September'].OTHER_WATER_FROM_WATER_STRESS_AREA, resData['October'].OTHER_WATER_FROM_WATER_STRESS_AREA,
              resData['November'].OTHER_WATER_FROM_WATER_STRESS_AREA, resData['December'].OTHER_WATER_FROM_WATER_STRESS_AREA],
              borderColor: 'rgba(255, 206, 86, 1)',
              backgroundColor: 'rgba(255, 206, 86, 0.5)',
            },
          ],
        }
        setWaterWithdrawalData(graph_dat);
      })
      .catch((error) => {
      });
  }
  
  const getDashboardData = (year, month, type = '') => {
    let frequencyParam = year + '-' + month + '-01';
    setFrequencyParam(frequencyParam);
    let cType = type ? type : configType;
    if (cType === "Supplier") {
      CompanyDashboardService.getDashboardData(
        companyId,
        glbRegulationId,
        frequencyParam
      )
        .then((response) => {
          setRiskParamData(response.data.riskParams);
          setCompanyRisk(response.data.companyRisk);
        })
        .catch((error) => {
        });
    } else {
      CompanyDashboardService.getCompanyRiskData(
        companyId,
        glbRegulationId,
        frequencyParam
      )
        .then((response) => {
          setRiskParamData(response.data.riskParams);
          setCompanyRisk(response.data.companyRisk);
        })
        .catch((error) => {
        });
    }

  };

  const getHighRiskSuppliers = (year, month) => {
    let frequencyParam = year + '-' + month + '-01';
    var string = Utils.generateUrlParamCompanyRegulation(
      companyId,
      glbRegulationId
    );
    var encodedDat = Utils.encodeBase64(string);
    CompanyDashboardService.getHighRiskSuppliers(encodedDat, frequencyParam)
      .then((response) => {
        setHighRiskSupplier(response.data);
      })
      .catch((error) => {
      });
  };

  const getTopCountryRisk = (year, month) => {
    let frequencyParam = year + '-' + month + '-01';
    CompanyDashboardService.getTopCountryRisk(
      companyId,
      glbRegulationId,
      frequencyParam
    ).then((response) => {
      let arrCountry = [];
      let arrCount = [];
      for (let i = 0; i < response.data.length; i++) {
        arrCountry.push(response.data[i].country);
        arrCount.push(response.data[i].total);
      }
      setLabelsCountry(arrCountry);
      const data = {
        labels: arrCountry,
        datasets: [
          {
            label: t("NoOfSuppliers.label"),
            data: arrCount,
            backgroundColor: "rgba(255, 99, 132, 0.5)",
          },
        ],
      };
      setCountryGraphData(data);
      setHighRiskCountries(response.data);
    }).catch((error) => {
    });
  };



  const highRiskProgressBarGenerate = (item) => {
    if (item) {
      if (item.resultType != null) {
        let colorClass = "color-" + item.resultType.colorCode.replace(/^#/, "");
        return (
          // 
          <><ProgressBar
            now={item.weightedScore * 10}
            // label={parseFloat(item.weightedScore.toFixed(1))}
            className={colorClass}
          /> {item.weightedScore != 0 && <span>{item.weightedScore.toFixed(1)}</span>}</>
        );
      } else {
        return (
          <><ProgressBar
            now={item.weightedScore * 10}
          // label={parseFloat(item.weightedScore.toFixed(1))}
          />{item.weightedScore != 0 && <span>{item.weightedScore.toFixed(1)}</span>}</>
        );
      }
    }
  };
  const callbackRisk = (data) => {
    setConfigType(data.configType);
    getDashboardData(annualyear, frequencymonth, data.configType);
  };

  const Workforce_Typedata = {
    labels: ['Contractors', 'Employees'],
    datasets: [
      {
        label: '# of Votes',
        data: [442, 2689],
        backgroundColor: [
          '#D7E5FD',
          '#C1EDC0',
        ],
        borderColor: [
          '#397FF4',
          '#07B401',
        ],
        borderWidth: 1.5,
      },
    ],
  };

  const Diversityemployees = {
    labels: ['Total female empolyees', 'Total male employees'],
    datasets: [
      {
        label: '# of Votes',
        data: [129, 345],
        backgroundColor: [
          '#D7E5FD',
          '#C1EDC0',
        ],
        borderColor: [
          '#397FF4',
          '#07B401',
        ],
        borderWidth: 1.5,
      },
    ],
  };
  const NewEmployeeHires = {
    labels: ['Total female new hires', 'Total male new hires'],
    datasets: [
      {
        label: '# of Votes',
        data: [129, 345],
        backgroundColor: [
          '#D7E5FD',
          '#C1EDC0',
        ],
        borderColor: [
          '#397FF4',
          '#07B401',
        ],
        borderWidth: 1.5,
      },
    ],
  };
  const TotalFemale = {
    labels: ['Total', 'Under 36 Yrs', '36-50 Yrs', 'Above 50 Yrs'],
    datasets: [
      {
        data: [500, 250, 100, 150],
        backgroundColor: [
          '#D7E5FD',
        ],
        borderColor: [
          '#397FF4',
        ],
        borderWidth: 1.5,
      },
    ],
  };
  const TotalMale = {
    labels: ['Total', 'Under 36 Yrs', '36-50 Yrs', 'Above 50 Yrs'],
    datasets: [
      {
        label: '',
        data: [750, 500, 150, 100],
        backgroundColor: [
          '#C1EDC0',
        ],
        borderColor: [
          '#07B401',
        ],
        borderWidth: 1.5,
      },
    ],
  };




  const EconomicValueDistributed = {
    labels: [
      'Operating costs',
      'Employee wages and benefits,',
      'Payments to providers of capital',
      'Payments to government by country',
      'Community investments',
    ],
    datasets: [
      {
        label: '# of Votes',
        data: [5, 70, 12, 3, 10],
        backgroundColor: [
          '#D7E5FD',
          '#C1EDC0',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
        ],
        borderColor: [
          '#397FF4',
          '#07B401',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
        ],
        borderWidth: 1.5,
      },
    ],
  };

  const labels3 = ['Company', 'Mine 1 -', 'Mine 2 -', 'Mine 3 -', 'Mine 4 -', 'Mine 5 -'];
  const DirectEconomicValueGenerated = {
    labels: labels3,
    datasets: [
      {
        label: 'Direct economic value generated: revenues',
        data: labels.map(() => faker.datatype.number({ max: 1000 })),
        backgroundColor: '#D7E5FD',
        borderColor: '#397FF4',
        borderWidth: 1.5,

      },
      {
        label: 'Total economic value distributed',
        data: labels.map(() => faker.datatype.number({ max: 1000 })),
        backgroundColor: '#C1EDC0',
        borderColor: '#07B401',
        borderWidth: 1.5,
      },

    ],
  };

  const getSupplierStatusCountryReport = () => {
    var month = Utils.getMonthFromFrequency(glbRegulation.frequency);
    CompanyDashboardService.getSupplierStatusCountryReport(
      companyId,
      glbRegulationId,
      annualyear + '-' + month + '-01',
    ).then((response) => {
      setCountryTopFive([...response.data])
    }).catch((error) => {
    });
  };

  const emissionsAcrossOrganization_toolip = (
    <Popover id="popover-trigger-hover-focus" className="p-2">
      <div className="p-1">
        Scope 1, Scope 2 & Scope 3 emissions across organization
      </div>
    </Popover>
  );
  const emissionsAcrossSite_toolip = (
    <Popover id="popover-trigger-hover-focus" className="p-2">
      <div className="p-1">
        Scope 1, Scope 2 & Scope 3 emissions across site
      </div>
    </Popover>
  );
  const setMetricCode = (id) => {
    localStorage.setItem(METRIC_CODE, id);
  }
  const analytics_tooltip = (
    <Popover id="popover-trigger-hover-focus" className="p-2">
      <div className="p-1">
        Show details
      </div>
    </Popover>
  );

  const getWorkForceType = () => {

    CompanyDashboardService.getWorkForceType(glbRegulation.id, `${annualyear}-01-01`)
      .then((response) => {
        var resData = response['data'].data;
        setTotalWorkForce(resData['TOTAL_WORKFORCE']);
        let workforce_dat = {
          options: {
            responsive: true,
            plugins: {
              legend: {
                position: "top",
                display: false,
              },
              title: {
                display: true,
                text: "",
              },
            },
          },

          labels: ['Contractors', 'Employees'],
          datasets: [
            {
              label: '# of Votes',
              data: [resData['NO_OF_CONTRACTORS'], resData['NO_OF_EMPLOYEES']],
              backgroundColor: [
                '#C1EDC0',
                '#D7E5FD',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
              ],
              borderColor: [
                '#07B401',
                '#397FF4',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
              ],
              borderWidth: 1.5,

            },

          ],
        }
        setWorkforce_Type(workforce_dat)
      })
      .catch((error) => {
      });
  };

  const getDiversity = () => {

    CompanyDashboardService.getDiversity(glbRegulation.id, `${annualyear}-01-01`)
      .then((response) => {
        var resData = response['data'].data;
        // setTotalWorkForce(resData['TOTAL_WORKFORCE']);
        let diversity_doughnut = {
          options: {
            responsive: true,
            plugins: {
              legend: {
                position: "top",
                display: false,
              },
              title: {
                display: true,
                text: "",
              },
            },
          },

          labels: ['Total female empolyees', 'Total male employees'],
          datasets: [
            {
              label: '# of Votes',
              data: [resData['TOTAL_FEMALE_EMPLOYEES'], resData['TOTAL_MALE_EMPLOYEES']],
              backgroundColor: [
                '#C1EDC0',
                '#D7E5FD',
              ],
              borderColor: [
                '#07B401',
                '#397FF4',
              ],
              borderWidth: 1.5,

            },

          ],
        };
        setDiversityDoughnut(diversity_doughnut);
        var TotalFemaleDat = {
          labels: ['Total', 'Under 36 Yrs', '36-50 Yrs', 'Above 50 Yrs'],
          datasets: [
            {
              data: [resData['TOTAL_FEMALE_EMPLOYEES'], resData['ED_FEMALE_UNDER_36_YEARS'], resData['ED_FEMALE_36_50_YEARS'], resData['ED_FEMALE_OVER_50_YEARS']],
              backgroundColor: [
                '#D7E5FD',
              ],
              borderColor: [
                '#397FF4',
              ],
              borderWidth: 1.5,
            },
          ],
        }
        setDiversityFemale(TotalFemaleDat);

        var TotalMaleDat = {
          labels: ['Total', 'Under 36 Yrs', '36-50 Yrs', 'Above 50 Yrs'],
          datasets: [
            {
              data: [resData['TOTAL_MALE_EMPLOYEES'], resData['ED_MALE_UNDER_36_YEARS'], resData['ED_MALE_36_50_YEARS'], resData['ED_MALE_OVER_50_YEARS']],
              backgroundColor: [
                '#C1EDC0',
              ],
              borderColor: [
                '#07B401',
              ],
              borderWidth: 1.5,
            },
          ],
        }
        setDiversityMale(TotalMaleDat);
      })
      .catch((error) => {
      });
  };

  const getNewHired = () => {

    CompanyDashboardService.getNewHired(glbRegulation.id, `${annualyear}-01-01`)
      .then((response) => {
        var resData = response['data'].data;
        let newhired_doughnut = {
          options: {
            responsive: true,
            plugins: {
              legend: {
                position: "top",
                display: false,
              },
              title: {
                display: true,
                text: "",
              },
            },
          },

          labels: ['Total female new hires', 'Total male new hires'],
          datasets: [
            {
              label: '# of Votes',
              data: [resData['TOTAL_FEMALE_NEW_HIRES'], resData['TOTAL_MALE_NEW_HIRES']],
              backgroundColor: [
                '#C1EDC0',
                '#D7E5FD',
              ],
              borderColor: [
                '#07B401',
                '#397FF4',
              ],
              borderWidth: 1.5,

            },

          ],
        };
        setNewHiresDoughnut(newhired_doughnut);
        var TotalFemaleDat = {
          labels: ['Total', 'Under 36 Yrs', '36-50 Yrs', 'Above 50 Yrs'],
          datasets: [
            {
              data: [resData['TOTAL_FEMALE_NEW_HIRES'], resData['FEMALE_UNDER_36_YEARS'], resData['FEMALE_36_50_YEARS'], resData['FEMALE_OVER_50_YEARS']],
              backgroundColor: [
                '#D7E5FD',
              ],
              borderColor: [
                '#397FF4',
              ],
              borderWidth: 1.5,
            },
          ],
        }
        setNewhireFemale(TotalFemaleDat);

        var TotalMaleDat = {
          labels: ['Total', 'Under 36 Yrs', '36-50 Yrs', 'Above 50 Yrs'],
          datasets: [
            {
              data: [resData['TOTAL_MALE_NEW_HIRES'], resData['MALE_UNDER_36_YEARS'], resData['MALE_36_50_YEARS'], resData['MALE_OVER_50_YEARS']],
              backgroundColor: [
                '#C1EDC0',
              ],
              borderColor: [
                '#07B401',
              ],
              borderWidth: 1.5,
            },
          ],
        }
        setNewhireMale(TotalMaleDat);
      })
      .catch((error) => {
      });
  };

  const handleTabChange = (key) => {
    setTabKey(key)
    if (key == 'Environmental') {

    } else if (key == 'Social') {
      getWorkForceType();
      getDiversity();
      getNewHired();
    }
  }

  const handleTopicChange = (val) => {
    setTopic(val);
  };

  return (
    <div className="CompanyDashboard mb-2">
      {glbRegulation?.type === 'R'
        ? <div className="CompanyDashboard_inner">
          {/* <AlertsAndTasksCountCard /> */}

          <div className="row m-0">




            <div className="col-lg-4 p-0">
              <CompanyRiskCard companyrisk={companyrisk} riskparamdata={riskparamdata} callbackRisk={callbackRisk} />
            </div>
            <div className="col-lg-8 p-0">
              <div>
                <SupplierRiskCountCard selYear={annualyear} />
              </div>
              <div className="row m-0">
                <div className="col-lg-6 Top5_cardin">
                  <div className="card mb-3 CD-Risk_02 border-0">
                    <div className="card-body p-0">
                      <div className="p-3">
                        <strong>{t("Top5HighRiskSuppliers.label")}</strong>
                      </div>
                      <div className="CD-Top5HighRiskSuppliersView02">
                        <div className="CD-Top5RiskView02_in">
                          <ul>
                            <li>
                              <p className="m-0"> {t("Suppliers.label")}</p>
                            </li>
                            <li>
                              <p className="m-0">{t("Score.label")} (1-10)</p>
                            </li>
                          </ul>
                        </div>
                        {highrisksupplier &&
                          highrisksupplier?.map((item, idx) => (
                            <div className="CD-Top5RiskView02_in" key={idx}>
                              <ul>
                                <li>{item.supplier.legalName}</li>
                                <li>{highRiskProgressBarGenerate(item)}</li>
                              </ul>
                            </div>
                          ))}
                        <div className="CD-Top5RiskView02_footer">
                          <a href="#">View More</a>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-6 Top5_cardin">
                  <div className="card mb-2 CD-Risk_02 border-0">
                    <div className="card-body p-0">
                      <div className="p-3">
                        <strong>{t("Top5HighRiskCountries.label")}</strong>
                      </div>

                      <div className="Top5HighRiskCountries_view">
                        <div className="CD-Top5HighRiskView02_in">
                          <ul>
                            <li>
                              <p className="m-0"> {t("Countries.label")}</p>
                            </li>
                            <li>
                              <p className="m-0">No.of Suppliers</p>
                            </li>
                          </ul>
                        </div>

                        {countrytopfive.map((item, idx) => (
                          <div className="CD-Top5HighRiskView02_in">
                            <ul>
                              <li>{item.country}</li>
                              <li>
                                <ProgressBar
                                  now={item.total}
                                //  label="new"
                                />{item.total > 0 && <span>{item.total}</span>}
                              </li>
                            </ul>
                          </div>
                        ))}



                        {/* <div className="CD-Top5HighRiskView02_footer">
                          <a href="#">View More</a>
                        </div> */}

                      </div>
                    </div>
                  </div>




                </div>
              </div>
            </div>


          </div>
        </div>
        : <div className="Standard_Dashboard_box 2">

          {/* <AlertsAndTasksCountCard /> */}
          <div className="p-0 Standard_Dashboard_box_tab">
            <button className="btn btn-secondary SD_tab_filter d-none"><CgSortAz /> Filter</button>
            <Tabs
              defaultActiveKey={tabkey}
              id="justify-tab-example"
              className="mb-0"
              // onSelect={(e) => handleTabChange(e)}
              onSelect={(k) => handleTabChange(k)}>
              <div className="Standrad_tabFilterbox 1">
                <div className="row m-0">
                  <div className="col-lg-3 col-md-4">
                    <label>Period</label>
                    <ul>
                      <li>
                        <select className="form-select" onChange={(e) => setAnnualYear(e.target.value)}>
                          {options}
                        </select>
                      </li>
                      {/* <li>
                        <select className="form-select">
                          <option>Q1</option>
                          <option>Q2</option>
                        </select>
                      </li> */}
                    </ul>
                  </div>
                  {
                    tabkey == 'Environmental' && 
                    <div className="col-lg-4 col-md-4">
                      <label>Topic</label>
                      <select className="form-select"
                        onChange={(e) => handleTopicChange(e.target.value)}>
                        <option value='Energy'>GRI 302:Energy</option>
                        <option value='Water'>GRI 303: Water</option>
                        <option value='Emission'>GRI 305: Emission</option>
                        <option value='Waste'>GR 306: Waste</option>
                      </select>
                    </div>
                  }                  
                  <div className="col-lg-3 col-md-4">
                    <label>Location</label>
                    <select className="form-select">
                      <option>All</option>
                    </select>
                  </div>
                </div>
              </div>

              <Tab eventKey="Environmental" title="Environmental">
                {topic == 'Energy' && <div>
                  <div className="row m-0">
                    <div className="col-lg-6 col-md-6 p-0">
                    { 
                      <CompanyGraphCard year={annualyear}
                        type={CompanyDashboardGraphType.ENERGY_PRODUCED} />
                    }
                    </div>
                    <div className="col-lg-6 col-md-6 p-0">
                     {
                       <CompanyGraphCard year={annualyear}
                        type={CompanyDashboardGraphType.ENERGY_CONS_WITHIN_ORG} />
                     }
                    </div>
                  </div>
                  <div className="row m-0">

                    <div className="col-lg-3 col-md-3 p-0">
                    {
                      tabkey === 'Environmental' &&
                      <CompanyGraphCard year={annualyear}
                        type={CompanyDashboardGraphType.AVG_EENRGY_INT_BY_ORE_MILLED} />
                    }
                    </div>
                    <div className="col-lg-3 col-md-3 p-0">
                    {
                      tabkey === 'Environmental' &&
                      <CompanyGraphCard year={annualyear}
                        type={CompanyDashboardGraphType.ENERGY_INT_BY_METAL_PROD} />
                    }
                    </div>

                    <div className="col-lg-6 col-md-6 p-0">  
                    {
                      tabkey === 'Environmental' &&
                      <CompanyGraphCard year={annualyear}
                        type={CompanyDashboardGraphType.ENERGY_CONS_OUTSIDE_ORG} />
                    }                    
                    </div>
                  </div>
                </div>}
                { 
                  topic == 'Emission' && 
                  <div className="row m-0">
                    <div className="col-lg-6 col-md-6 p-0">
                      <CompanyGraphCard year={annualyear}
                          type={CompanyDashboardGraphType.SCOPE_123_EMISSION} />
                    </div>
                    <div className="col-lg-6 col-md-6 p-0">
                    <CompanyGraphCard year={annualyear}
                          type={CompanyDashboardGraphType.SCOPE_123_EMISSION_ACROSS_SITE} />
                    </div>
                  </div>
                }
                {
                  topic == 'Waste' && 
                  <div className="row m-0">
                    <div className="col-lg-6 col-md-6 p-0">
                      <CompanyGraphCard year={annualyear}
                        type={CompanyDashboardGraphType.WASTE_GEN_IN_ORG}/>
                    </div>
                    <div className="col-lg-6 col-md-6 p-0">
                      <CompanyGraphCard year={annualyear}
                        type={CompanyDashboardGraphType.WASTE_DISPOSAL}/>
                    </div>
                  </div>
                }
                {
                  topic == 'Water' && 
                  <div className="row m-0">
                    <div className="col-lg-6 col-md-6 p-0">
                      <div className="card Energy_Produced_card border-top-0">
                        <div className="Energy_Produced_card-header">
                          <h6 className="m-0">Total water withdrawal in the organization (in Megaliters)</h6>
                          <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement="bottom"
                            overlay={emissionsAcrossOrganization_toolip}
                          >
                            <span><BsInfoCircle /></span>
                          </OverlayTrigger>
                        </div>
                        <div className="card-body pt-0">
                          {
                            // TODO Remove later >> BAD Practice
                            isDemoEnv && (companyId === 150 || companyId === 151)
                            ? <EmptyGraphDataCard />
                            :
                            <div className="">
                              <Bar data={water_withdrawal_data} options={Stacked_options} />
                            </div>
                          }                        
                          {/* <div className="text-center p-2 text-dark">
                            Emission intensity by ore milled <strong>0.0140</strong> (t Scope 1 & Scope 2 Co2-e)
                          </div> */}
                          {/* <div className="Energy_Produced_card-footer mt-2">
                            <div>
                              <h5>0.0140 kCO2 - e/t</h5>
                              <b>Emission intensity by ore milled</b>
                            </div>
                            <div className="Compared_box01">
                              <h6>+9.6%</h6>
                              <b>Compared to 2022 Q4</b>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 p-0">
                      <CompanyGraphCard year={annualyear}
                        type={CompanyDashboardGraphType.TOTAL_WATER_CONS_IN_ORG}/>
                    </div>
                  </div>
                }
              </Tab>
              <Tab eventKey="Social" title="Social">
                <div className="row m-0">
                  <div className="col-lg-6 col-md-12 p-0">

                    <div className="card  Energy_Produced_card">
                      <div className="Energy_Produced_card-header">
                        <h6 className="m-0">Workforce type</h6>
                      </div>
                      <div className="card-body pt-0 Energy_Produced_card_body d-flex justify-content-center">
                        <div className="col-lg-7 col-md-7 p-0">
                          <div className="Workforcedata_graph">
                            <Doughnut data={Workforce_Type} options={graphoptions_right} />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 p-0">
                    <div className="card  Energy_Produced_card">
                      <div className="Energy_Produced_card-header">
                        <h6 className="m-0">Diversity of employees</h6>
                      </div>
                      <div className="card-body pt-0 Energy_Produced_card_body justify-content-center align-items-center">
                        <div className="col-lg-5 col-md-12 p-0">
                          <div className="Workforcedata_graph_02">
                            <Doughnut data={diversity_doughnut} />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12 p-0">
                          <div>
                            <div>
                              <b>Male</b>
                            </div>
                            <div className="mb-3">
                              <Bar data={diversity_male} options={graphoptions_Horizontal} />
                            </div>
                          </div>
                          <div>
                            <div>
                              <b>Female</b>
                            </div>
                            <div className="">
                              <Bar data={diversity_female} options={graphoptions_Horizontal} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

             
                  <div className="col-lg-6 col-md-6 p-0">
                    <div className="card  Energy_Produced_card border-top-0">
                      <div className="Energy_Produced_card-header">
                        <h6 className="m-0">New employees hired</h6>
                      </div>
                      <div className="card-body pt-0 Energy_Produced_card_body justify-content-center align-items-center">
                        <div className="col-lg-5 col-md-12 p-0">

                          <div className="Workforcedata_graph_02">
                            <Doughnut data={newhires_doughnut} />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12 p-0">
                          <div>
                            <div>
                              <b>Male</b>
                            </div>
                            <div className="mb-3">
                              <Bar data={newhire_male} options={graphoptions_Horizontal} />
                            </div>
                          </div>
                          <div>
                            <div>
                              <b>Female</b>
                            </div>
                            <div className="">
                              <Bar data={newhire_female} options={graphoptions_Horizontal} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  { 
                    tabkey === 'Social' && 
                    <CompanyGraphCard year={annualyear}
                      type={CompanyDashboardGraphType.SOCIAL_EMPLOYMENT}/>
                  }                  
                </div>
              </Tab>
              <Tab eventKey="Governance" title="Governance">
                <div className="row m-0">
                  <div className="col-lg-6 col-md-6 p-0">
                  {
                    tabkey === 'Governance' &&
                    <CompanyGraphCard year={annualyear}
                      type={CompanyDashboardGraphType.ECONO_VALUE_DISTRIBUTED} />
                  }
                  </div>

                  <div className="col-lg-6 col-md-6 p-0">
                  {
                    tabkey === 'Governance' &&
                    <CompanyGraphCard year={annualyear}
                      type={CompanyDashboardGraphType.ECONO_VALUE_GENERATED} />
                  }
                  </div>
                  <div className="col-lg-6 col-md-6 p-0">
                  {
                    // TODO Remove later >> BAD Practice
                    tabkey === 'Governance' && isDemoEnv && (companyId === 150 || companyId === 151) &&
                    <CompanyGraphCard year={annualyear}
                      type={CompanyDashboardGraphType.SUSTAINABLE_FINANCE} />
                  }
                  </div>
                </div>
              </Tab>

            </Tabs>
          </div>
        </div>}
    </div >
  );
};
export default withTranslation()(CompanyDashboardOLD);
